import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c(VBtn,{staticClass:"mt-1",attrs:{"depressed":"","small":""},on:{"click":_vm.reset}},[_c('span',{staticClass:"d-flex flex-gap-8 align-center"},[_vm._v(" "+_vm._s(_vm.$t('Reset all'))+" "),_c(VIcon,[_vm._v("refresh")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }